import React, { Component } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from "./components/authentification/PrivateRoute";

import HomePage from "./components/Pages/HomePage";
import Error from "./components/Error";
import Register from "./components/authentification/Register";
import Login from "./components/authentification/Login";
import Logout from "./components/authentification/Logout";
import UserProfile from "./components/user/UserProfile";
import UserProfileEdit from "./components/user/UserProfileEdit";
import FavoriteUser from "./components/dashboard/FavoriteUser";
import MapPlaces from "./components/map/MapPlaces";

import Pointofinterest from "./components/pointofinterest/Pointofinterest";
import PointOfInterestView from "./components/pointofinterest/PointOfInterestView";
import CreatePointofinterest from "./components/pointofinterest/CreatePointofinterest";
import EditPointofinterest from "./components/pointofinterest/EditPointofinterest";

import Experience from "./components/experience/Experience";
import ExperienceView from "./components/experience/ExperienceView";
import CreateExperience from "./components/experience/CreateExperience";
import EditExperience from "./components/experience/EditExperience";

import UserPointsofinterest from "./components/pointofinterest/UserPointsofinterest";
import UserExperiences from "./components/experience/UserExperiences";
import UserNotifications from "./components/notification/UserNotifications";
import FavoriteMapPlaces from "./components/map/FavoriteMapPlaces";

import Sensors from "./components/sensors/Sensors";

import "./newTheme/css/style.css";
import "./newTheme/css/plugins.css";
import "./newTheme/css/dashboard-style.css";
import ReviewUser from "./components/dashboard/ReviewUser";
import TermsAndConditionsPage from "./components/Pages/TermsAndConditionsPage";
import PrivacyPolicyPage from "./components/Pages/PrivacyPolicyPage";


class App extends Component {
    render() {
        return (
            <div className="h-screen App min-h-[600px]">
                {/* https://dev.to/lautaro/dynamic-routes-in-react-router-v6-569m */}
                <Router>
                    <Routes>
                        {/* <Route path="/" exact element={<PrivateRoute><Home /></PrivateRoute>} /> */}
                        <Route path="/" exact element={<HomePage />} />
                        <Route path="/register" exact element={<Register />} />
                        <Route path="/login" exact element={<Login />} />
                        <Route path="/logout" exact element={<Logout />} />
                        <Route path="/terms" exact element={<TermsAndConditionsPage />} />
                        <Route path="/privacy-policy" exact element={<PrivacyPolicyPage />} />


                        <Route path="/map" exact element={<MapPlaces />} />

                        <Route
                            path="/user/profile"
                            exact
                            element={
                                <PrivateRoute>
                                    <UserProfile />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/map/favorite"
                            exact
                            element={
                                <PrivateRoute>
                                    <FavoriteMapPlaces />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/user/favorite"
                            exact
                            element={
                                <PrivateRoute>
                                    <FavoriteUser />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/user/review"
                            exact
                            element={
                                <PrivateRoute>
                                    <ReviewUser />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/user/profile/edit"
                            exact
                            element={
                                <PrivateRoute>
                                    <UserProfileEdit />
                                </PrivateRoute>
                            }
                        />

                        <Route
                            path="/user/pointsofinterest"
                            exact
                            element={
                                <PrivateRoute>
                                    <UserPointsofinterest />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/user/experiences"
                            exact
                            element={
                                <PrivateRoute>
                                    <UserExperiences />
                                </PrivateRoute>
                            }
                        />

                        {/* <Route path="/pointofinterest/:pointofinterestId" exact element={<Pointofinterest />} /> */}
                        <Route path="/pointofinterest/:pointofinterestId" exact element={<PointOfInterestView />} />
                        <Route
                            path="/pointofinterest/create"
                            exact
                            element={
                                <PrivateRoute>
                                    <CreatePointofinterest />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/pointofinterest/:pointofinterestId/edit"
                            exact
                            element={
                                <PrivateRoute>
                                    <EditPointofinterest />
                                </PrivateRoute>
                            }
                        />

                        {/* <Route path="/experience/:experienceId" exact element={<Experience />} /> */}
                        <Route path="/experience/:experienceId" exact element={<ExperienceView />} />
                        <Route
                            path="/experience/create"
                            exact
                            element={
                                <PrivateRoute>
                                    <CreateExperience />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/experience/:experienceId/edit"
                            exact
                            element={
                                <PrivateRoute>
                                    <EditExperience />
                                </PrivateRoute>
                            }
                        />

                        <Route
                            path="/user/pointsofinterest"
                            exact
                            element={
                                <PrivateRoute>
                                    <UserPointsofinterest />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/user/experiences"
                            exact
                            element={
                                <PrivateRoute>
                                    <UserExperiences />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/user/notifications"
                            exact
                            element={
                                <PrivateRoute>
                                    <UserNotifications />
                                </PrivateRoute>
                            }
                        />

                        <Route path="/sensors" exact element={<Sensors />} />

                        <Route path="/subscription" exact element={<UserProfile />} />

                        <Route path="/error/404" exact element={<Error />}></Route>
                        <Route>404 Not found</Route>
                    </Routes>
                </Router>
            </div>
        );
    }
}

export default App;
